
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import EnhancedCalendar from '../EnhancedCalendar';
import { CalendarSectionProps } from './types';

const CalendarSection: React.FC<CalendarSectionProps> = ({
  psychologistId,
  selectedDate,
  onDateSelect,
  onConfigureClick
}) => {
  return (
    <div className="lg:col-span-2 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Calendário de Disponibilidade</h3>
        {selectedDate && (
          <Button onClick={onConfigureClick} size="sm">
            <Plus className="h-4 w-4 mr-2" />
            Configurar Horários
          </Button>
        )}
      </div>
      
      <EnhancedCalendar
        psychologistId={psychologistId}
        selectedDate={selectedDate}
        onDateSelect={onDateSelect}
      />
    </div>
  );
};

export default CalendarSection;
